/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

var destroy = require('./plugin/destroy')
  , initialize = require('./plugin/initialize')
  , update = require('./plugin/update');

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};




/*****************
 ** WEBPACK FOOTER
 ** ./~/perfect-scrollbar/src/js/main.js
 ** module id = 1529
 ** module chunks = 0
 **/